export const fmtMoney = (n) =>
  n == null || n === "" ? "—" : `${Math.round(Number(n)).toLocaleString("fr-FR")} FCFA`;

export const fmtNum = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString("fr-FR"));

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return isNaN(dt) ? String(d) : dt.toLocaleDateString("fr-FR");
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return isNaN(dt) ? String(d) : dt.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const toDatetimeLocal = (d) => {
  const dt = d ? new Date(d) : new Date();
  const pad = (x) => String(x).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};
